var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_9",
    "data-name": "Calque 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 860.01 694.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#66463a;}.cls-4{fill:#3f2922;}.cls-5{fill:#8c675b;}.cls-6{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-323.99 -797)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M952,805H532c-32.87,1-54.94,5.74-67,14L327,954c-7,9-1.57,19.33,14,24l28,9,85,1,34,499c0,6.29,23,6.29,23,0l-11-464h53.43L569,1277c0,5.59,16,5.59,16,0l-2.84-254H952Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-323.99 -797)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M556,805H976c32.87,1,54.94,5.74,67,14l138,135c7,9,1.57,19.33-14,24l-28,9-85,1-34,499c0,6.29-23,6.29-23,0l11-464H954.56L939,1277c0,5.59-16,5.59-16,0l2.84-254H556Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "table") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M952,805H532c-32.87,1-54.94,5.74-67,14L327,954c-7,9-1.57,19.33,14,24l28,9,85,1,34,499c0,6.29,23,6.29,23,0l-11-464h53.43L569,1277c0,5.59,16,5.59,16,0l-2.84-254H952Z",
    transform: "translate(-323.99 -797)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "166.01 225 628.01 225 628.01 189.76 166.01 190 166.01 225"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M952,970.62,357,971c-28.22-2.6-40.87-9.52-21.49-25.33C335.51,945.67,468,805,470,805s482-8,482-8Z",
    transform: "translate(-323.99 -797)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M556,805H976c32.87,1,54.94,5.74,67,14l138,135c7,9,1.57,19.33-14,24l-28,9-85,1-34,499c0,6.29-23,6.29-23,0l11-464H954.56L939,1277c0,5.59-16,5.59-16,0l2.84-254H556Z",
    transform: "translate(-323.99 -797)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "694 225 232 225 232 189.76 694 190 694 225"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M556,970.62l595,.38c28.22-2.6,40.87-9.52,21.49-25.33,0,0-132.49-140.67-134.49-140.67s-482-8-482-8Z",
    transform: "translate(-323.99 -797)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.04b5440bc9122bdc897576feb7ab4967.svg";
export { ForwardRef as ReactComponent };